export default __webpack_public_path__ + "static/media/digital-skills-training-banner-april-04-2025.df85d4b0.png";